import { TypeStoreDetail } from "@/lib/redux/features/store/type";

export const getPageSizeProducts = (storeData: TypeStoreDetail) => {
  return storeData.grid_products * 4
}